import script from "./CadenceCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./CadenceCreate.vue?vue&type=script&setup=true&lang=js"

import "./CadenceCreate.vue?vue&type=style&index=0&id=36aa04d2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36aa04d2"]])

export default __exports__